import React from 'react';
import { Link } from 'react-router-dom';
import { Eyebrow } from './SectionHead';
import Button from './Button';

/**
 * PageHero — L1 narrative hero for interior pages (05 §3.0).
 */
const PageHero = ({ eyebrow, title, lead, children, breadcrumb }) => (
  <section className="cy-section" style={{ paddingTop: 96, paddingBottom: 88 }}>
    <div className="cy-container">
      <div className="cy-page-hero" style={{ maxWidth: 'min(100%, 820px)' }}>
        {breadcrumb}
        {eyebrow ? <Eyebrow>{eyebrow}</Eyebrow> : null}
        <h1 className="cy-h1">{title}</h1>
        {lead ? <p className="cy-lede">{lead}</p> : null}
        {children}
      </div>
    </div>
  </section>
);

const HeroCtas = ({ primary, primaryTo, secondary, secondaryTo, commit }) => (
  <div className="cy-hero-cta" style={{ marginTop: 40, display: 'flex', flexWrap: 'wrap', gap: 16, alignItems: 'center' }}>
    <Button to={primaryTo}>{primary}</Button>
    {secondary ? (
      <Link className="cy-link" to={secondaryTo}>
        {secondary}
      </Link>
    ) : null}
    {commit ? <p className="cy-btn-commit" style={{ flexBasis: '100%' }}>{commit}</p> : null}
  </div>
);

export { HeroCtas };
export default PageHero;
